import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import { User, UsersAction, UsersTypes } from '../types';
import { addUser, deleteUser, editUser, getList, getUsersByIds, userError } from '../actions';
import {
    getUsersFirebase,
    addUserFirebase,
    deleteUserFirebase,
    editUserFirebase,
    sendGlobalNotificationFirebase,
    getUsersFirebaseByIds,
    sendUserNotificationFirebase,
} from '../repository';
import strings from '../../../resources/strings';

export function* requestGetListSaga(props: UsersAction<{ roles: string[] }>): unknown {
    try {
        const users = yield call(getUsersFirebase, props.payload.roles);
        yield put(getList(users));
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.getUsers}, error: ${err}`));
    }
}

export function* requestAddUserSaga(props: UsersAction<User>): unknown {
    try {
        const user = props.payload;
        const userData = yield call(addUserFirebase, user);
        yield put(addUser(userData));
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.addUser}, error: ${err}`));
    }
}

export function* requestDeleteUserSaga(props: UsersAction<{ uid: string }>): unknown {
    try {
        const uid = props.payload.uid;
        const userData = yield call(deleteUserFirebase, uid);
        yield put(deleteUser(userData));
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.deleteUser}, error: ${err}`));
    }
}

export function* requestEditUserSaga(props: UsersAction<{ uid: string; newRole: string }>): unknown {
    try {
        const uid = props.payload.uid;
        const newRole = props.payload.newRole;

        const role = yield call(editUserFirebase, uid, newRole);
        yield put(editUser(uid, role));
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.editUser}, ${err}`));
    }
}

export function* requestSendGlobalNotificationSaga(props: UsersAction<{ type: string }>): unknown {
    try {
        yield call(sendGlobalNotificationFirebase, props.payload.type);
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.sendNotification}, error: ${err}`));
    }
}

function* requestGetUsersByIds(props: UsersAction<{ uids: string[]; roles: string[] }>): unknown {
    try {
        const { uids, roles } = props.payload;
        const users = yield call(getUsersFirebaseByIds, uids, roles);
        yield put(getUsersByIds(users));
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.getUsers}, error: ${err}`));
    }
}
export function* requestSendUserNotificationSaga(
    props: UsersAction<{ type: string; uid: string; uidFrom: string }>,
): unknown {
    try {
        yield call(sendUserNotificationFirebase, props.payload.type, props.payload.uid, props.payload.uidFrom);
    } catch (err: unknown) {
        yield put(userError(`${strings.usersPage.errors.sendNotification}, error: ${err}`));
    }
}

export default [
    takeLatest(UsersTypes.REQUEST_GET_LIST, requestGetListSaga),
    takeLatest(UsersTypes.REQUEST_ADD_USER, requestAddUserSaga),
    takeLatest(UsersTypes.REQUEST_DELETE_USER, requestDeleteUserSaga),
    takeLatest(UsersTypes.REQUEST_EDIT_USER, requestEditUserSaga),
    takeLatest(UsersTypes.REQUEST_SEND_GLOBAL_NOTIFICATION, requestSendGlobalNotificationSaga),
    takeEvery(UsersTypes.REQUEST_GET_USERS_BY_IDS, requestGetUsersByIds),
    takeLatest(UsersTypes.REQUEST_SEND_USER_NOTIFICATION, requestSendUserNotificationSaga),
];
